import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Communicates tab index changes to components that are already mounted.
 *
 * When a notification is clicked and the target page is already active,
 * Angular ignores the navigation (same URL). In that case the notification
 * menu calls `emitTab` instead of navigating, and the target component
 * subscribes to `tab$` to update its active tab in-place.
 *
 * Components arriving from a different route still read the tab index from
 * `history.state.tab` in their constructor — this service only covers the
 * already-on-page case.
 */
@Injectable({ providedIn: 'root' })
export class TabNavigationService {
  private tabSubject = new Subject<number>();

  /**
   * Emits whenever a tab change is requested for the currently active page.
   */
  readonly tab$ = this.tabSubject.asObservable();

  /**
   * Signals subscribers to switch to the given tab index.
   */
  public emitTab(tab: number): void {
    this.tabSubject.next(tab);
  }
}
